import React from "react";

import Text from "src/components/text";
import { formatTimespent } from "src/services/reports.service";

import styles from "./userGroupCard.module.scss";
import { UserGroup } from "src/types/users";
import { Analytics } from "src/types/reports";

export interface UserGroupCardProps {
  item: {
    userGroup: UserGroup;
    analytics: Analytics;
  };
}

export const UserGroupCard: React.FC<UserGroupCardProps> = ({ item }) => {
  const { userGroup, analytics } = item;
  return (
    <a
      href={`/settings/user-management/group/${userGroup.id}`}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.linkWrapper}
    >
      <div className={styles.card}>
        <div className={styles.content}>
          <div className={styles.imageIcon}>
            {userGroup?.icon?.thumbnail ? (
              <img src={userGroup.icon.thumbnail} alt="User Icon" />
            ) : (
              <span className={styles.initials}>
                {userGroup.name?.charAt(0).toUpperCase() || "U"}
              </span>
            )}
          </div>
        </div>
        <div className={styles.info}>
          <Text
            lines={1}
            className={styles.title}
            text={userGroup.name || ""}
          />
          <div className={styles.metrics}>
            <span>{analytics.views || 0} Views</span>
            <span>{formatTimespent(analytics.avgTimeSpent || 0)} Avg Time </span>
            <span>{analytics.shares || 0} Shares</span>
          </div>
        </div>
      </div>
    </a>
  );
};
